// node glob stand-in: no filesystem, so no pattern ever matches.
function glob(_pattern, options, callback) {
    if (typeof options === "function") {
        callback = options;
    }
    if (typeof callback === "function") {
        setTimeout(() => callback(null, []), 0);
        return undefined;
    }
    return Promise.resolve([]);
}

glob.glob = glob;
glob.sync = () => [];
glob.globSync = () => [];
glob.hasMagic = () => false;
glob.default = glob;

module.exports = glob;
